export const appName = 'Estuda-Comigo'
